import { FC, useMemo } from 'react';
import { AmlHistoryItemData } from '@/redux/models';
import { TransactionSignals, AddressSignals } from './components';

interface RiskDetailsSignalsFullProps {
  item: AmlHistoryItemData;
}

const RiskDetailsSignalsFull: FC<RiskDetailsSignalsFullProps> = (props) => {
  const { item } = props;

  const isTransaction = useMemo(() => !!item.tx, [item.tx]);

  return (
    <>
      {isTransaction ? (
        <TransactionSignals item={item} />
      ) : (
        <AddressSignals item={item} />
      )}
    </>
  );
};

export default RiskDetailsSignalsFull;
